import {
  FormMultiSelector,
  TooltipContent,
  TooltipTrigger,
  Typography,
  Tooltip,
  Button,
} from '@ui/components';
import { RequestFieldFilterType } from '@interfaces/models';
import { useTranslation } from 'react-i18next';
import { Delete } from '@ui/components/icons';
import { Control } from 'react-hook-form';
import { cn } from '@ui/utils';
import React from 'react';

interface EmployeesTableForm {
  [RequestFieldFilterType.EMPLOYEE_PROFILE]: string[];
  [RequestFieldFilterType.EMPLOYEE_SERVICE]: string[];
}

interface EmployeesTableFiltersProps extends React.ComponentPropsWithoutRef<'div'> {
  controls: Control<EmployeesTableForm>;
  reset: () => void;
  isLoading?: boolean;
  options: {
    services: { label: string; value: string }[];
    profiles: { label: string; value: string }[];
  };
}

export function EmployeesTableFilters({
  className,
  isLoading,
  controls,
  options,
  reset,
}: EmployeesTableFiltersProps) {
  const { t } = useTranslation();

  return (
    <div className={cn('flex gap-4 justify-between', className)}>
      <div className="flex gap-4 flex-wrap">
        <FormMultiSelector
          placeholder={t('EMPLOYEES.TABLE_HEADER_PROFILE')}
          name={RequestFieldFilterType.EMPLOYEE_PROFILE}
          className="min-w-50 w-71 flex-1"
          options={options.profiles}
          formControl={controls}
          disabled={isLoading}
          size="small"
        />
        <FormMultiSelector
          placeholder={t('EMPLOYEES.TABLE_HEADER_SERVICES')}
          name={RequestFieldFilterType.EMPLOYEE_SERVICE}
          className="min-w-50 w-71 flex-1"
          options={options.services}
          formControl={controls}
          disabled={isLoading}
          size="small"
        />
      </div>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button onClick={reset} variant="ghost" icon>
            <Delete />
          </Button>
        </TooltipTrigger>

        <TooltipContent className="w-auto">
          <Typography variant="labelXSmallBook">
            {t('EMPLOYEES.TABLE_HEADER_CLEAR_FILTERS')}
          </Typography>
        </TooltipContent>
      </Tooltip>
    </div>
  );
}
